import { FirmAdmin } from 'components/FirmAdminList/FirmAdminInterface/FirmAdminInterface';
import { ReducerItemsState } from 'shared/interface/globalInterface';
import { Nullable } from 'utils/types';

export type AdminTypeProps = {
  fcaNumber: string;
  club: string;
};

export type CompanyDetails = {
  firstName: string;
  surname: string;
  email: string;
  contactNumber: string;
  additionalPermissions: string;
};

export type AdminViewModel = {
  id: string;
  name: string;
  email: string;
  fcaNumber: string;
  role: string;
  company: string;
  isVerified: boolean;
  activeLabel: 'YES' | 'No';
  buttonActivationLabel: 'Verify' | 'Unverify';
  location: string;
};

export type AdminDetails = {
  id: number;
  firstName: string;
  lmcRefNumber: Nullable<string>;
  lastName: string;
  fcaNumber: string;
  company: string;
  isVerified: boolean;
  address: {
    postcode: string;
    buildingNumber: string;
    buildingName: string;
    street: string;
    city: string;
    county: string;
  };
  email: string;
  contactNumber: string;
};

export type FirmAdminResponse = {
  created_at: string;
  email: string;
  id: number;
  is_verified: boolean;
  lmc_ref_number: Nullable<string>;
  first_name: string;
  last_name: string;
  phone: string;
  post_code: string;
  house_number: string;
  street_line_1: string;
  street_line_2: string;
  city: string;
  county: string;
  company: {
    name: string;
    fca_number: string;
  };
};

export type FirmAdminUpdateRequest = {
  email?: string;
  post_code: string;
  house_number: string;
  street_line_1?: string;
  street_line_2?: string;
  city: string;
  county?: string;
  phone?: string;
};

export type Club = {
  id: string;
  name: string;
};

export type State = {
  strategy?: RegisterStrategy;
  admins: FirmAdmin[];
  clubs: ReducerItemsState<Club>;
};

export const ACTION_TYPES = {
  ADD_ADMIN: 'ADMINS/ADD_ADMIN',
  STORE_ADMINS: 'ADMINS/STORE_ADMINS',
  SET_STRATEGY: 'ADMINS/SET_STRATEGY',

  FETCH_CLUBS_PENDING: 'ADMINS/POSITIONS/PENDING',
  FETCH_CLUBS_FETCHED: 'ADMINS/CLUBS/FETCHED',
  FETCH_CLUBS_ERROR: 'ADMINS/CLUBS/ERROR',
  CLEAR: 'ADMINS/CLEAR_DATA',
};

export enum CompanyType {
  FIRM = 'FIRM',
  NETWORK = 'NETWORK',
  CLUB = 'CLUB',
}

export type Detail = {
  label: string;
  value: string;
};

export type SaveAdminData = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  [key: string]: string;
  additional_permissions: string;
};

export interface RegisterStrategy {
  getDataEndpoint: () => string;
  getDetails: (data: any) => Detail[];
  mapDataForSave: (data: CompanyDetails) => SaveAdminData;
}
